// extracted by mini-css-extract-plugin
export var root = "_1YVQ";
export var rootImage = "aoTg";
export var rootPicture = "Vdvl";
export var rootPictureLabel = "+yPf";
export var rootPictureLabelWrapper = "zG9f";
export var rootPictureWrapper = "DLP5";
export var rootProduct = "_8wdZ";
export var rootProductPrice = "n5uq";
export var rootProductPriceRegular = "zUaA";
export var rootProductPriceSale = "bOMN";
export var rootProductPriceWrapper = "JGlg";
export var rootProductTitle = "f45X";
export var rootTileLink = "BT7Y";